import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";

declare var ko: any;

export interface subContentArticle {

    position:               string;
    label:                  string;
    permalink:              string;
    reference:              string;
    isMainPage:             boolean;
    idArticle:              string;
    article:                object;
}

export class subContentArticles_template extends vnTemplate {

    protected parent: any;

    protected getTemplateHtml(): string {

        return /* html */`

            <div class="form-body" data-bind="foreach: articles, childrenComplete : handleDragAndDrop($element, articles ,'.entry')">

                <div class="form-group w-pinned">

                    <div class="pinned-form article entry">

                        <div class="pinned-drag icon i-drag">
                            <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                        </div>

                        <div class="w-btn">
                            <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDelete }"><span class="hidden-text">Delete</span></button>
                        </div>

                        <div class="form-group auto-feild">

                            <span class="form-label" data-bind="visible: !article">There's nothing currently selected</span>
                            <!-- ko if: article != null -->
                            <span class="form-label icon i-article" data-bind="text: article.title" ></span>
                            <button class="btn border only-icon icon border i-link" type="button" data-bind="event: { click: $parent.onClickView }"><span class="hidden-text">View</span></button>
                            <!-- /ko -->
                            <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEdit }"><span class="hidden-text">Edit</span></button>
                        </div>


                        <div class="form-group" data-bind="visible: $parent.articles().length > 1">
                            <label for="" class="form-label" data-bind="css: { 'disabled': isMainPage}">Permalink</label>
                            <input class="input-text" type="input"  data-bind="css: { 'disabled': isMainPage}, value: permalink">
                            <div class="form-check-inline width-auto">
                                <input type="radio" data-bind="attr: { id: 'radio_' + ($index() + 1) }, , value: true, checked: isMainPage, event: { change: $parent.onMainPageSelected }" name="subContent-radio-group">
                                <label class="form-label" data-bind="attr: { for: 'radio_' + ($index() + 1) }">Main Page</label>
                            </div>
                        </div>

                        <div class="form-group" data-bind="visible: $parent.articles().length > 1">
                            <label for="" class="form-label">Label</label>
                            <input class="input-text" type="input" data-bind="value: label">
                        </div>

                    </div>
                </div>
            </div>
                  
            <div data-bind="visible: articles().length == 0">
                <p class="form-text">There is nothing currently added.</p>
            </div>
               
        `;
    }

    protected getTemplateName(): string {
        return "subContentArticles-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected initPartial() {

    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
             maximum: ko.observable(25)
            ,isToolTipVisible: ko.observable(false)
            ,articles: ko.observableArray([])
            ,label: ko.observable('')
            ,permalink: ko.observable('')
            ,onMainPageSelected: function(data, event){
                huit_neuf_this.onMainPageSelected(data);
            }
            ,onClickEdit: function (data, event) {
                huit_neuf_this.onClickEdit(data);
            }
            ,onClickDelete: function (data, event) {
                huit_neuf_this.onClickDelete(data);
            },
            onClickView: function(data, event) {
                huit_neuf_this.onClickView(data);
            }
            ,handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){
                huit_neuf_this.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
            }
            
        };
    }

    public setParent(parent){
        this.parent = parent;
    }

    public onClickAdd(){

        if(this.getTemplateViewModel().articles().length == this.getTemplateViewModel().maximum()) {
            this.caller.triggerNotification('Maximum number reached. Please delete one to add new! ');
            return;
        }

        let article : subContentArticle =  {
            'idArticle': null,
            'reference': null,
            'article': null,
            'label': null,
            'permalink': null,
            'position': this.getTemplateViewModel().articles().length + 1,
            'isMainPage': false
        }

        let articles = this.getTemplateViewModel().articles();
        if (articles.length == 0) {
            article.isMainPage = true;
        }
        articles.push(article);

        this.getTemplateViewModel().articles([]);
        this.getTemplateViewModel().articles(articles);
    }

    public onClickEdit(data){

        let articles = this.getTemplateViewModel().articles();
        let index = this.getArticleIndex(data);
        if(index > -1){
            this.parent.editSubContentArticle(articles[index]);
        }
    }

    public onClickDelete(data){

        let index = this.getArticleIndex(data);
        let articles = this.getTemplateViewModel().articles();
        if(index > -1){
            let deletedArticle = articles[index];

            articles.splice(index, 1);
            
            // Update positions
            this.updatePositions();

            // If the deleted article was the main page, set another article as the main page
            if (deletedArticle.isMainPage && articles.length > 0) {
                articles[0].isMainPage = true; // Set the first article as the main page
            }

            this.getTemplateViewModel().articles([]);
            this.getTemplateViewModel().articles(articles);
        }
    }

    public onClickView(data) {

        let articles = this.getTemplateViewModel().articles();
        let index = this.getArticleIndex(data);
        if(index > -1){
            this.caller.viewArticle(articles[index].idArticle);
        }
    }

    public onMainPageSelected(data) {
        let index = this.getArticleIndex(data);
        if (index > -1) {
            let articles = this.getTemplateViewModel().articles();
            articles.forEach((article, i) => {
                article.isMainPage = (i === index); // Set isMainPage to true for the selected article
            });
            this.getTemplateViewModel().articles([]);
            this.getTemplateViewModel().articles(articles);
        }
    }

    public getArticleIndex(data){

        let articles = this.getTemplateViewModel().articles();
        let index = articles.findIndex(article => article.position == data.position);
        return index;
    }

    public updatePositions(){

        let articles =  this.getTemplateViewModel().articles();
        for (let i = 0; i < articles.length; i++) {

            articles[i].position = i + 1;
        }

        this.getTemplateViewModel().articles([])
        this.getTemplateViewModel().articles(articles)
    }

    public addSubContentArticle(data){
        let articles = this.getTemplateViewModel().articles();
        let index = this.getArticleIndex(data);
        if(index > -1){
            articles[index] = data;
            this.getTemplateViewModel().articles([]);
            this.getTemplateViewModel().articles(articles);
        }
    }

    public handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
    }

    public setMaximum(maximum){

        this.getTemplateViewModel().maximum(maximum)
    }

    public setArticles(articles: Array<any>): void {

        if(articles && articles.length > 0){
            this.getTemplateViewModel().articles(articles);
        }
    }

    public clearArticles(): void
    {
        this.getTemplateViewModel().articles([]);
    }

    public getArticles(){

        //update positions first
        this.updatePositions();
        return this.getTemplateViewModel().articles();
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/subContentArticles_template.ts